<template>
    <div>
        <ListingModel category="ISSUE"/>
    </div>
</template>

<script>
import ListingModel from "@/views/Notification/ControlProgram/Components/ListingModel.vue";

export default {
    name: "ControlIssues",
    components: {ListingModel},
}
</script>

<style scoped>

</style>